import React from 'react';
import NavbarComponent from './Navbar';

const Header = () => {
    return <NavbarComponent />
}

export default Header;